module.exports = __webpack_public_path__ + "img/PcContent2.777fa8b4.png";